<template>
    <b-container fluid>
        <h4>Your Purchases</h4>
        <h6>Click a column header to sort the table.</h6>
        <div class="section-line" />
        <b-form-row>
            <b-col md="4" class="my-2">
                <b-input-group prepend="Filter">
                    <b-form-input v-model="filter" placeholder="Type to filter the table." />
                    <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">
                            Clear
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>

            <b-col md="4" class="my-2">
                <ay-select v-model="aySelected" :ay-default="isReviewer ? currentAy : null" />
            </b-col>

            <b-col md="4" class="my-2">
                <b-button-group>
                    <b-button class="csv-button-text">
                        Download all purchases as CSV
                    </b-button>
                    <b-button id="csv-download-button"
                              v-b-tooltip.hover
                              title="Download a single CSV file containing all
                              Purchases for all Institutions at selected year"
                              class="csv-download-button"
                              @click="downloadAllCsv"
                    >
                        <fa-icon
                            fixed-width
                            size="lg"
                            :icon="['fas', 'download']"
                        />
                    </b-button>
                </b-button-group>
            </b-col>
        </b-form-row>
        <applicationListTable
            id="application-list-table"
            :items="applicationListItems"
            :actions="actionItems"
            :filter="filter"
            :ay-select="aySelected"
            @row-clicked="viewApplicationPurchases"
            @download-clicked="downloadCsv"
        />
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { alertManager as AlertManager } from '@/plugins/alertManager';

export default {
    name: 'ApplicationList',

    metaInfo() {
        return { title: 'Annual Plans' };
    },

    data() {
        return {
            filter: null,
            aySelected: null,
            actionItems: [{
                name: 'download',
                icon: ['fas', 'download'],
                iconVariant: 'outline-mono-2',
                tooltip: 'Download as CSV',
            }],
        };
    },

    computed: {
        ...mapGetters({
            isReviewer: 'auth/isReviewer',
            applications: 'application/applicationList',
            currentAy: 'ref/global/currentAy',
            applicantName: 'ref/ee/ficeName',
            applicationsById: 'application/applicationsById',
        }),

        applicationListItems() {
            return this.applications.map((app) => {
                app.applicant_name = this.applicantName(app.applicant_id);
                return app;
            });
        },
    },

    created() {
        this.$store.dispatch('ref/ee/fetchRefEe', this.currentAy);
        this.$store.dispatch('application/fetchApplicationList');
    },

    methods: {
        viewApplicationPurchases(item) {
            const applicationAcademicYear = this.applicationsById && this.applicationsById[item.application_id]
                ? this.applicationsById[item.application_id].academic_year
                : this.currentAy;
            this.$router.push({
                name: 'purchases',
                params: {
                    applicationId: item.application_id,
                    academicYear: applicationAcademicYear,
                },
            });
        },

        downloadCsv(app) {
            const url = process.env.VUE_APP_API_URL + 'applications/' + app.application_id + '/purchases/csv';
            window.open(url, '_blank');
        },

        async downloadAllCsv(app) {
            try {
                const url = process.env.VUE_APP_API_URL + 'purchases/' + this.aySelected + '/csv';
                await window.open(url, '_blank');

                AlertManager.showSuccess({ message: 'Successfully downloaded the CSV file.' });
            } catch (error) {
                AlertManager.showErr(error);
            }
        },
    },
};
</script>

<style lang="scss">
h4 {
    text-align: center;
}
h6 {
    text-align: center;
}
td.table-success {
    vertical-align: middle;
    text-align: center;
}
table#list-of-applications {
    vertical-align: middle;
    text-align: center;
}
tr {
    cursor: pointer;
}

.csv-button-text {
    color: #2c3e50;
    background-color: #e9ecef;
    cursor: default;
    border-color: #ced4da;
}

.csv-download-button {
    color: #2C6400;
    border-color: #2b64002c;
    background-color: #2b64002c;
    &:hover {
        color: white;
        background-color: #2C6400;
    }
}
</style>
